import { FileUploadS3, FileUploadS3Props } from "@certn/cascadia-react";

import { baseFileTypes } from "../../utils/file-types";

interface Props extends Omit<FileUploadS3Props, "requestUrl"> {
  applicantId: string;
  documentType: string;
  documentSubtype?: string;
}

export function ApplicantDocumentUpload(props: Props) {
  const { applicantId, documentType, documentSubtype, ...fileUploadProps } =
    props;

  return (
    <FileUploadS3
      fileTypes={baseFileTypes}
      maxSizeBytes={10000000}
      {...fileUploadProps}
      requestUrl={`/internal/people/applicant/${applicantId}/document/create`}
      requestPayload={{
        document_type: documentType,
        document_subtype: documentSubtype,
      }}
    />
  );
}
